import { LOADED, usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useWebmasterStore, } from '@/assets/js/src/modules/webmasters/_pinia/webmasters'
import { computed, } from 'vue'

export function useWebmastersApi () {
    let activePinia = getActivePinia()
    let webmasterStore = useWebmasterStore(activePinia)
    let { bibles,meta, } = storeToRefs(webmasterStore)
    let { messagesLoaded,asyncStatus, } = usePrefetchData({
        actions: [
            {
                item: bibles,
                action: webmasterStore.fetchBibles,
            },
        ],
        loadAsyncMessages: [ 'webmasters', 'common', ],
    })

    const asyncStatusLoaded = computed(()=>asyncStatus.value === LOADED)

    return {
        asyncStatusLoaded,
        messagesLoaded,
        bibles,
        meta,
    }
}
